"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _lodash = require("lodash");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./EditApiKeyWhitelistIpAddresses.css");
var _APInput = _interopRequireDefault(require("../../common/APInput"));
var _APChip = _interopRequireDefault(require("../../common/APChip/APChip"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _EditApiKeyWhitelistIpAddressesContainer = require("./EditApiKeyWhitelistIpAddressesContainer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('create-api-key');
var removeApiKeyModalClasses = (0, _cssClassesHelper.getBEMClasses)('edit-api-key-whitelist-ip-addresses-modal');
var IpWhiteListErrors = new Map([['Empty', 'Please enter a value.'], ['Max', 'You can only add 3 IP Addresses to Whitelist.'], ['IP', 'IP address is not valid']]);
var isValidIPv4 = function isValidIPv4(ip) {
  var ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  return ipv4Pattern.test(ip);
};
var EditApiKeyWhitelistIpAddressesModal = function EditApiKeyWhitelistIpAddressesModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    IpWhiteList = _useState6[0],
    setIpWhiteList = _useState6[1];
  (0, _react.useEffect)(function () {
    if (props.payload && !(0, _lodash.isEmpty)(props.payload.IpWhiteList)) {
      var IpWhitelistedIpAddress = props.payload.IpWhiteList.split(',');
      var updatedIpWhiteList = _toConsumableArray(IpWhitelistedIpAddress);
      setIpWhiteList(updatedIpWhiteList);
    }
    return function () {
      setIpWhiteList([]);
    };
  }, [props.payload]);
  var onRemoveIpAddress = function onRemoveIpAddress(IPAddress) {
    var newIpAddresses = _toConsumableArray(IpWhiteList);
    var filteredIpAddresses = newIpAddresses.filter(function (ip) {
      return ip !== IPAddress;
    });
    setIpWhiteList(filteredIpAddresses);
  };
  var onAddIPAddress = function onAddIPAddress(event) {
    event.preventDefault();
    setError(undefined);

    // Find the value from clicking add button since its not in redux form
    var value = event.currentTarget.parentElement.parentElement.children[1].value;
    if (!isValidIPv4(value)) {
      setError('IP');
      return;
    }
    if ((0, _lodash.isEmpty)(value)) {
      setError('Empty');
    } else if (IpWhiteList.length >= 3) {
      setError('Max');
    } else {
      var newIpAddresses = [].concat(_toConsumableArray(IpWhiteList), [value]);
      setIpWhiteList(newIpAddresses);

      // Set values in Redux Form so they will show in payload
      props.changeFieldValue('IpWhiteList', _toConsumableArray(newIpAddresses).join(','));

      // Reset ReduxForm Field so entered value is cleared.
      props.changeFieldValue('IpWhiteListInput', '');
    }
  };
  var onSubmitForm = function onSubmitForm() {
    var IpWhiteListAddresses = _toConsumableArray(IpWhiteList).join(',');
    var updatedPayload = _objectSpread(_objectSpread({}, props.payload), {}, {
      IpWhiteList: IpWhiteListAddresses
    });
    (0, _EditApiKeyWhitelistIpAddressesContainer.formSubmit)(updatedPayload, props.dispatch);
    setError('');
  };
  var onModalClose = function onModalClose() {
    setIpWhiteList([]);
    setError('');
    props.closeModal();
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t('Edit Api Key Whitelist Ip Addresses'),
    customClass: "retail-api-keys-modal-delete",
    close: onModalClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: removeApiKeyModalClasses('text')
  }, t('Edit, Add or Delete the Whitelisted Ip Addresses for this Api Key.')), /*#__PURE__*/_react["default"].createElement("section", {
    className: "create-api-key-ip-whitelist"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    className: "create-api-key-ip-form",
    id: "editApiKeyWhiteListIpAddresses",
    onSubmit: props.handleSubmit(onSubmitForm)
  }, IpWhiteList.length > 0 && /*#__PURE__*/_react["default"].createElement(_APChip["default"], {
    values: IpWhiteList,
    onCloseClick: onRemoveIpAddress
  }), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    buttonInInput: true,
    placeholder: "-",
    name: "IpWhiteListInput",
    onButtonClick: onAddIPAddress
  }), !(0, _lodash.isEmpty)(error) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "create-api-key-ip-whitelist__error"
  }, IpWhiteListErrors.get(error)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "create-api-key__footer"
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    styleName: "subtractive",
    customClass: baseClasses(),
    onClick: onModalClose
  }, t('Cancel')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    customClass: baseClasses(),
    disabled: submitting,
    styleName: "additive",
    form: "editApiKeyWhiteListIpAddresses"
  }, submitting ? t('Processing...') : t('Update Ip Addresses'))));
};
EditApiKeyWhitelistIpAddressesModal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  apiKey: _propTypes["default"].string,
  closeModal: _propTypes["default"].func.isRequired,
  close: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = EditApiKeyWhitelistIpAddressesModal;